import { loadScript, removeScripts } from 'common-utils';

import { TrackingTool, UserDetails } from '../tracking-tool';

declare global {
  interface Window {
    clarity: {
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      (action: string, ...args: any[]): Promise<{
        id: string;
        session?: string;
        page?: string;
        userHint?: string;
      }>;
      q: IArguments[];
    };
  }
}

export class MsClarity implements TrackingTool {
  private readonly _id: string;

  constructor(id: string) {
    this._id = id;
  }

  async turnOff() {
    removeScripts(['clarity']);
  }

  async turnOn() {
    window['clarity'] =
      window['clarity'] ||
      function () {
        (window['clarity'].q = window['clarity'].q || []).push(arguments);
      };
    await loadScript(`https://www.clarity.ms/tag/${this._id}`);
  }

  getName(): string {
    return 'msClarity';
  }

  trackSpecialEvent = {
    signIn: async (userDetails: UserDetails) => {
      const customId = userDetails.ssoId.toString();
      await window.clarity('identify', customId);
    },
  };
}
